import { render } from "./MedicalInfo.vue?vue&type=template&id=d3561906&scoped=true"
import script from "./MedicalInfo.vue?vue&type=script&lang=js"
export * from "./MedicalInfo.vue?vue&type=script&lang=js"

import "./MedicalInfo.vue?vue&type=style&index=0&id=d3561906&scoped=true&lang=css"

import exportComponent from "/Volumes/INNCOM/MUSOON Project/2103.musoon.mobile.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3561906"]])

export default __exports__